<template>
  <router-view />
</template>
<script>
export default {
  name: 'AppEntryPoint',
  data () {
    return {
      configJson: {},
    }
  },
  created () {
    this.configJson = this.$store.getters.getConfigJson
    if (this.configJson.colorSchema) {
      const colorSchema = this.configJson.colorSchema
      Object.keys(colorSchema).forEach(i => {
        this.$vuetify.theme.themes.dark[i] = colorSchema[i]
        this.$vuetify.theme.themes.light[i] = colorSchema[i]
      })
    }
  },
}
</script>
<style>
.v-input--selection-controls__ripple {
    display: none;
}
.theme--light.v-icon:focus::after {
     opacity: 0 !important;
}
.esri-view .esri-view-surface--inset-outline:focus::after {
  outline: none !important;
}
*:focus {
    outline: none;
}
html,body {
  font-family: Rubik, sans-serif;
}
#app {
  font-family: Rubik, sans-serif;
}
@import url('https://fonts.googleapis.com/css?family=Rubik:100,300,400,500,700,900&display=swap');
@import "../node_modules/@arcgis/core/assets/esri/themes/light/main.css";
@import  "../node_modules/tabulator-tables/dist/css/tabulator.min.css";

</style>
